// extracted by mini-css-extract-plugin
export var activeProfiles = "platform-card-module--activeProfiles--46eb3";
export var activeProfilesSubText = "platform-card-module--activeProfilesSubText--de2cb";
export var asterisk = "platform-card-module--asterisk--c9dc2";
export var button = "platform-card-module--button--8b566";
export var buttonContainer = "platform-card-module--buttonContainer--d5327";
export var cardContents = "platform-card-module--cardContents--3c242";
export var description = "platform-card-module--description--7d0fc";
export var discount = "platform-card-module--discount--a7ed7";
export var divider = "platform-card-module--divider--611c1";
export var featuresListContainer = "platform-card-module--featuresListContainer--8aadf";
export var pillText = "platform-card-module--pillText--3de4e";
export var pillTextContainer = "platform-card-module--pillTextContainer--29f82";
export var planName = "platform-card-module--planName--0ee50";
export var planNameContainer = "platform-card-module--planNameContainer--bc797";
export var platformCard = "platform-card-module--platformCard--84ea3";
export var price = "platform-card-module--price--4a4e8";
export var priceDescription = "platform-card-module--priceDescription--6311c";
export var priceInfo = "platform-card-module--priceInfo--d8c6d";
export var priceWrapper = "platform-card-module--priceWrapper--cf29c";
export var sliderWrapper = "platform-card-module--sliderWrapper--62fbb";
export var timePeriod = "platform-card-module--timePeriod--bdfa6";